import { useEffect } from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import './index.css';
import App from './app';
import reportWebVitals from './reportWebVitals';
import './translation/i18n';
import { Provider, useDispatch } from 'react-redux';
import store from './store/store';
import { setupAxiosInterceptors } from './services';
import { NotificationProvider, useNotification } from './components';

const root = ReactDOM.createRoot(document.getElementById('root') as HTMLElement);

const NotificationSetup = () => {
  const { addNotification } = useNotification();
  const dispatch = useDispatch();

  useEffect(() => {
    setupAxiosInterceptors(addNotification, dispatch);
  }, [addNotification]);

  return null;
};

root.render(
  <BrowserRouter>
    <Provider store={store}>
      <NotificationProvider>
        <NotificationSetup />
        <App />
      </NotificationProvider>
    </Provider>
  </BrowserRouter>,
);

reportWebVitals();
